// Dev-only render-count overlay (§9.3.7). A rAF loop writes the counts into a
// static DOM node — displaying the instrument causes zero React renders.

import { useEffect, useRef } from 'react';

import { renderCounts } from '../perf/renderProbe';

export function PerfOverlay() {
  const preRef = useRef<HTMLPreElement>(null);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    let raf = 0;
    const draw = () => {
      const el = preRef.current;
      if (el) {
        el.textContent = [...renderCounts.entries()]
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([k, v]) => `${k}: ${v}`)
          .join('\n');
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, []);

  if (!import.meta.env.DEV || !window.location.search.includes('perf=1')) return null;
  return <pre ref={preRef} className="bz-perf-overlay" />;
}
